/* eslint-disable import/extensions,import/no-unresolved,react/prefer-stateless-function,import/no-duplicates,import/no-named-as-default-member */

import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import {
  Route,
  Switch,
} from 'react-router-dom';

import LoginPage from 'containers/Login/Loadable';
import NotFoundPage from 'containers/NotFoundPage/Loadable';
import FastCoverWizardPage from 'containers/FastCover/Loadable';
import ClaimListPage from 'containers/ClaimList/Loadable';
import PrivateRoute from 'containers/PrivateRoute';
import routeConfig from 'utils/routeConfig';
import ProgressBar from 'containers/ProgressBar';
import Notification from 'containers/Toastr';
import SummaryScreen from '../SummaryScreen';
import PostSubmit from '../PostSubmit/Loadable';
import PostSubmitSCTI from '../PostSubmitSCTI/Loadable';

const AppWrapper = styled.div`
  max-width: 852px;
  margin: 0 auto;
  display: flex;
  // min-height: 100%;
  padding: 0 16px;
  flex-direction: column;
`;

export default class App extends React.Component {

  render() {
    return (
      <AppWrapper>
        <Helmet
          titleTemplate="Appsure FNOL"
          defaultTitle="Appsure FNOL"
        >
          <meta
            name="description"
            content="Appsure FNOL application"
          />
        </Helmet>
        <ProgressBar />
        <Switch>
          <Route exact path={routeConfig.login} component={LoginPage} />
          <PrivateRoute
            path={routeConfig.claimList}
            component={ClaimListPage}
          />
          <PrivateRoute
            path={routeConfig.claimWizard}
            component={FastCoverWizardPage}
          />
          <Route path={routeConfig.postSubmit} component={PostSubmit} />
          <Route path={routeConfig.postSubmitSCTI} component={PostSubmitSCTI} />
          <Route path="/summary/:token/:verifyCode/:policyNumber/:claimNumber" component={SummaryScreen} />
          <Route path="" component={NotFoundPage} />
        </Switch>
        <Notification />
      </AppWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./app/containers/App/index.js